import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import Field from "../ui/inputs/Field";
import VCodeInput from "../ui/inputs/VCodeInput";
import ApiProxy from "@root/ts/ApiProxy";
import EZAlert from "./EZAlert";
import FormTools from "@root/ts/FormTools";
import Tools from "@root/ts/Tools";
import Popups from "./Popups";
import LoginBindLine from "./LoginBindLine";
import login_send_vcode from "@schema/common/login-send-vcode.json";
import login_register from "@schema/common/login-register.json";
import Captcha from "../ui/inputs/Captcha";

export default class LoginRegister extends PopupBase
{
  static instance: LoginRegister;
  // _vcodeInput: VCodeInput;

  private _captcha: Captcha;

  constructor(elem: ComponentElem)
  {
    super(elem);

    LoginRegister.instance = this;

    // let $inputs = this.$root.find("input").val("");

    let $btnSend = this.$root.find(".btn-send");

    this._captcha = this.seekComponentByName("captcha");
    this._captcha.emitter.on("token-change", (token: string) =>
    {
      token ?
        $btnSend.removeAttr("disabled") :
        $btnSend.attr("disabled", "true");
    });

    $btnSend.on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      
      let result = this.getFormData();

      console.dir(result.formData);
      

      if(result.isReady)
      {
        // console.log(result.formData); return;
        
        FormTools.sendForm("common/login-register", result.formData, this.$root, {schema: login_register, exampleIndex: 0, autoCloseAlert: false}).then((response: any)=>
        {
          // LoginBindLine.instance.setNextUrl(response.next_url);
          // Popups.to("login-invite");

          EZAlert.instance.alert("感謝註冊EZOUTDOOR", "請前往您的信箱，開啟驗證連結，即可正式完成會員註冊！", "知道了");
          
        }).catch(()=>
        {
          this.toMe();
        });
        
      }
      else
      {
        if(result.errorFeedback)
        {
          EZAlert.alert(result.errorFeedback.title, result.errorFeedback.text, false).then(()=>
          {
            this.toMe();
          })
        }
      }
      
      
    });
  }

  toMe()
  {
    this._captcha.ready().then(()=>
    {
      this.reset();
      Popups.to("login-register");
    });
  }

  reset()
  {
    this.$root.find(".btn-send").attr("disabled", "true");
    this._captcha.reset();
  }

  // private _setupVcode()
  // {
  //   let phoneField: Field = <Field>this.seekComponentByField("phone");

  //   this._vcodeInput = this.seekComponentByName("vcode-input") as VCodeInput;

  //   this._vcodeInput.vcodeEmitter.on("request", ()=>
  //   {
  //     let phoneData = phoneField.getValue();
  //     // console.log(phoneData);

  //     if(phoneData)
  //     {
  //       EZAlert.pending(true);
  //       ApiProxy.callApi("common/login-send-vcode", {phone: phoneData}, {schema: login_send_vcode}).then((result)=>
  //       {
  //         EZAlert.pending(false);

  //         let duration = Tools.parseInt(result.live_duration);
  //         this._vcodeInput.countDown(duration);

  //         EZAlert.alert("驗證螞已送出", "請在時間內送出表單", false).then(()=>
  //         {
  //           this.toMe();
  //         })

  //       }).catch((error)=>
  //       {
  //         EZAlert.pending(false);
  //         EZAlert.alert(error.message, undefined, false).then(()=>
  //         {
  //           this._vcodeInput.changeState("default");
  //           this.toMe();
  //         });
  //       });

  //     }
  //     else
  //     {
  //       phoneField.toggleError(true, "請輸入手機號碼");
  //     }

  //   });

  //   this._vcodeInput.vcodeEmitter.on("timeout", ()=>
  //   {
  //     this._vcodeInput.changeState("reload");
  //   });
  // }

  getFormData()
  {
    let result = FormTools.getFormData(this.$root);
    result.formData.captcha_token = this._captcha.token;

    if (!this._captcha.token) {
      result.isReady = false;
      result.errorFeedback = {title: "請先完成驗證"};
    }

    if(result.formData.password_1 && result.formData.password_2)
    {
      if(result.formData.password_1 !== result.formData.password_2){
        let field: Field = <Field>this.seekComponentByField("password_2");
        field.toggleError(true, "再次密碼輸入的密碼不相同");
        result.isReady = false;
      }

      result.formData.password = result.formData.password_1;
      
      delete result.formData.password_1;
      delete result.formData.password_2;
    }

    // if(this._vcodeInput.getState() !== "countdown")
    // {
    //   result.isReady = false;
    //   result.errorFeedback = {title: "驗證碼 尚未送出 或 已經過期"};
    // }

    if(!result.formData["eula_agree"])
    {
      result.isReady = false;
      result.errorFeedback = {title: "您必須同意 隱私權政策 和 服務條款 才能成為會員"};
    }
    

    return result;
  }
}